function clearRejectedCookies(a) {
    if (+a === 0) clearAnalyticsCookies();
}
function clearCookiesByPrefix(prefixes) {
    var h = location.hostname;
    var domains = ['', h, '.' + h];
    var p = h.split('.');
    if (p.length > 2) domains.push('.' + p.slice(1).join('.'));
    document.cookie.split(';').forEach(function(c) {
        var name = c.trim().split('=')[0];
        if (prefixes.some(function(px) { return name === px || name.indexOf(px) === 0; })) {
            domains.forEach(function(d) {
                var v = name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
                if (d) v += ';domain=' + d;
                document.cookie = v;
            });
        }
    });
}
function clearAnalyticsCookies() {
    window['ga-disable-G-J2T2DMW45C'] = true;
    clearCookiesByPrefix(['_ga', '_gid']);
}
